import axios from 'axios'

export const getGhnServiceSupport = (data) => {
  return axios.post('services/check-ghn-support', data)
}

export const getCarierLocation = (data) => {
  return axios.post('services/check-carrier-location', data)
}



// WEBPACK FOOTER //
// ./src/api/checkService.js